import React, {useEffect} from 'react';
import {Route, Switch, useHistory} from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";
import {useDispatch, useSelector} from "react-redux";
import {
    fetchCustomers, fetchRiskCycleDetailsPagewise,
    fetchRiskCycleReport,
    fetchRiskPortfolio,
    setCustomerInView,
    setEntityInView
} from "../../../actions";
import {
    bbDoesCustomerHaveAccessToSubscriptionLevel,
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf, bbGetSubscriptionLevelPropertyFromIdOrName,
    bbGetSubscriptionPropertyFromIdOrName,
    bbIsBetasOk,
    getFirstCustomerId,
    isCurrentUserMemberOf,
    showBBNotification
} from "../../../util/bbHelpers";
import URLSearchParams from "url-search-params";
import MultiBoardWrapper from "../cirt/routes/MultiBoardWrapper";
import UsersGuidePage from "./UsersGuidePage";
import {INFO} from "../../../constants/ActionTypes";

function PageRoutes({match, betasOk, authUser}) {
    return(
        <div className="px-3 py-4">
            <Switch>
                <Route path={`${match.url}/`} component={UsersGuidePage}/>
                <Route path={`${match.url}/:section`} component={UsersGuidePage}/>

                <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
            </Switch>
        </div>
    );
}

const UserGuideRoutes = ({match}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, selfEntityId, loadingCycles, loadingCycleDetails} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");


    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const customer = customers ? customers[customerInView] : null;

    const subscriptions = customer && Object.values(customer.Subscriptions)
    const hasActiveBRfBSubscription = subscriptions && subscriptions.filter((sub)=> sub.subscription_type && sub.subscription_type.id === 2 && sub.is_active).length;
    const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk") || hasActiveBRfBSubscription;

    const applicableSubscriptionTypeId = bbGetSubscriptionPropertyFromIdOrName("BRfB", "id");
    const applicableSubscriptionLevelId = bbGetSubscriptionLevelPropertyFromIdOrName("lite", "id");
    const doesUserHaveALiteSubscriptionOrHigher = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, applicableSubscriptionTypeId, applicableSubscriptionLevelId, true);


    const history = useHistory();
    const dispatch = useDispatch();
    const numCustomers = customers ? Object.keys(customers).length : 0;

    useEffect(() => {

        if (customers == null && authUser) {
            console.log("Customers is empty, fetching from CIRTPages. numCustomers is ", numCustomers);
            dispatch(fetchCustomers());
        }
        if (numCustomers && customerInView === null) {
            const defaultId = getFirstCustomerId(customers);
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setCustomerInView(defaultId));
        }
        /*  jfd*******************************
                 *   Fetch Portfolios
                     ********************************** */

        // console.log("About to fetch BreachRisk stuff. Here is customers", customers, "And here is in view", customer)

        if (customers && customer && authUser && !portfolios && !loadingPortfolios[customerInView]) {
            // console.log("Portfolios is empty, fetching for customerId", customer.CustomerId);
            dispatch(fetchRiskPortfolio({
                customerId: customer.CustomerId
            }));
        }

        /*  jfd*******************************
                 *   Set entityInView
                     ********************************** */
        if (portfolios
            && portfolios[customerIdToUse]
            && portfolios[customerIdToUse].self
        ) {
            const defaultId = portfolios[customerIdToUse].self.id;
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setEntityInView(defaultId));
            // console.log("set the entity in view to Self", defaultId);
        }
        /*  jfd*******************************
                 *   Fetch The latest cycle
                     ********************************** */

        // console.log("Checking to see if last cycle is already loaded", myEntity);
        if (myEntity
            && authUser
            && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", myEntity.id)
            && myEntity.settings
            &&  myEntity.settings.last_cycle_id
            && (!myEntity.cycles || !myEntity.cycles[myEntity.settings.last_cycle_id])
            && !loadingCycles[myEntity.settings.last_cycle_id]) {
            // console.log("myEntity exists but the last cycle (",myEntity.settings.last_cycle_id,") is empty, fetching that cycle.", myEntity.cycles);
            dispatch(fetchRiskCycleReport({
                cycleId: myEntity.settings.last_cycle_id,
                customerId: customerIdToUse
            }));
        }

        /*  jfd*******************************
                 *   Fetch The latest cycle details (tech data)
                 * Only do this if has a Lite subscription or higher
                     ********************************** */

        // console.log("Checking to see if last cycle is already loaded", myEntity, "authUser", authUser, "loadingCycles", loadingCycles, "loadingCycleDetails", loadingCycleDetails);
        if (myEntity
            && authUser
            && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", myEntity.id)
            //TODO: restore this check for Lite subscription once we update such that all tiles on tech page only rely on summary data (see Slack convo https://breachbits.slack.com/archives/GLM5SQC2Z/p1657044367751359)
            // && (doesUserHaveALiteSubscriptionOrHigher || isAdmin || isStaff)
            && myEntity.settings
            && myEntity.cycles
            && myEntity.cycles[myEntity.settings.last_cycle_id] //if there is already a cycle
            && !loadingCycles[myEntity.settings.last_cycle_id]
            // && !myEntity.cycles[myEntity.settings.last_cycle_id].techData //if no tech data
            && !loadingCycleDetails[myEntity.settings.last_cycle_id] //if not already loading them
            // && ( //attempt to prevent this branch from executing if we already know we have all the pages
            //     ( //safely check to see if haven't caught all pages
            //         myEntity.cycles[myEntity.settings.last_cycle_id].techData
            //         && myEntity.cycles[myEntity.settings.last_cycle_id].techData.meta
            //         && myEntity.cycles[myEntity.settings.last_cycle_id].techData.meta.highestPageFetched
            //         && myEntity.cycles[myEntity.settings.last_cycle_id].techData.meta.pages
            //         && myEntity.cycles[myEntity.settings.last_cycle_id].techData.meta.highestPageFetched < myEntity.cycles[myEntity.settings.last_cycle_id].techData.meta.pages
            //     ) || !myEntity.cycles[myEntity.settings.last_cycle_id].techData //of if first page hasn't even been fetched
            // )
        ) {
            // console.log("Fetching tech data for last cycle (",myEntity.settings.last_cycle_id,") is empty, fetching.");
            const techData = myEntity.cycles[myEntity.settings.last_cycle_id].techData
            //determine what page should be fetched.
            var pageNumToFetch = null;

            //if there is no techData, then fetch page 1.
            if (!techData){ //if no tech data
                pageNumToFetch = 1;
            } else if ( //if there are pages that have not yet been fetched (first version of this Dec '21 will be simple and assume previous pages have been fetched)
                //TODO: Logic of this should be more robust. Figure out how to tell which records are missing so you can fetch the correct page?
                //look at the techData meta to see the highest page number that has been fetched
                //compare this to the number of pages available
                //if there are more pages to fetch
                techData.meta
                && techData.meta.highestPageFetched
                && techData.meta.pages
                && techData.meta.highestPageFetched < techData.meta.pages
            ) {
                //set the next page to fetch as the next highest page
                pageNumToFetch = techData.meta.highestPageFetched + 1;

                //some load times can be long - give users occasional notifications
                //every 10th page, let them know.
                // if (pageNumToFetch % 30 === 0) {
                //     const percentCompleteLoading = Math.floor(pageNumToFetch/techData.meta.pages * 100) ;
                //     showBBNotification(INFO, "Loading BreachRisk™ Technical In Progress", `${percentCompleteLoading}% complete, now fetching segment ${pageNumToFetch} of ${techData.meta.pages}`, false);
                // }


            } else if (
                techData.meta
                && techData.meta.highestPageFetched
                && techData.meta.pages
                && techData.meta.highestPageFetched >= techData.meta.pages) {

                //no need to fetch a page because highest page meet or exceeds max pages.
                console.log("All tech details pages have been fetched. Won't fetch.", techData.meta.highestPageFetched, "out of", techData.meta.pages);
                pageNumToFetch = null;

                //if there were a lot of pages, let them know loading is complete
                // if (techData.meta.pages > 2) {
                //     // const percentCompleteLoading = Math.floor(pageNumToFetch/techData.meta.pages) * 100;
                //     showBBNotification(SUCCESS, "Loading BreachRisk™ Technical Complete", `Loading complete. ${techData.meta.pages} data segments loaded.`, false);
                // }

            } else {
                console.warn("usermanual Unexpected reason to not fetch another tech details page. Will not fetch. techData", techData, "pageNumToFetch", pageNumToFetch, "myEntity", myEntity, "customerIdToUse", customerIdToUse )
                pageNumToFetch = null;
            }

            //if we got a valid page number, fetch the details
            if (pageNumToFetch) {
                console.log("Fetching details page", pageNumToFetch);
                dispatch(fetchRiskCycleDetailsPagewise(
                    myEntity.settings.last_cycle_id,
                    customerIdToUse,
                    pageNumToFetch
                ));
            }
        }


        /*  jfd*******************************
         *   Appending clientID to URL
             ********************************** */
        const params = new URLSearchParams(window.location.search);

        if ((isPartner
            || isAdmin
            || isStaff
        )) {
            //if they are a partner, staff, or admin, append the clientID search param

            if(customers
                && !params.has("clientID")
                && customerInView
            ) {
                //set the urlParameters
                params.set("clientID", customerInView)
                // console.log("getting params", params.get("clientID"));
                history.replace({
                    search: params.toString(),
                })
            }
        }

    }, [dispatch, customers, customerInView, window.location.search,portfolios, loadingPortfolios, loadingCycles, loadingCycleDetails,
        authUser, customer, customerIdToUse, entityInView, history, isAdmin, isPartner, isStaff, myEntity, numCustomers]);


    if (isCurrentUserMemberOf(authUser, "admin") || (!authUser.customers && !authUser.customers.isEmpty()) || (authUser.customers && authUser.customers.length > 1)) {
        return (
            <MultiBoardWrapper customer={customer} isAdmin={isCurrentUserMemberOf(authUser, "admin")}>
                <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)}/>
            </MultiBoardWrapper>
        )
    } else if (isCurrentUserMemberOf(authUser, "customer") && !isCurrentUserMemberOf(authUser, "admin")){
        return (
            <>
                <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)} authUser={authUser}/>
            </>
        )
    } else {
        return (
            <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)}/>
        )
    }
};

export default UserGuideRoutes;